import { Tab } from "@headlessui/react";
import { useTranslation } from "react-i18next";

export enum Language {
  RU = "RU",
  EN = "EN",
}

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ");
}

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleClick = (languageIndex: number) => {
    return i18n.changeLanguage(
      languageIndex === 0
        ? Language.RU.toLowerCase()
        : Language.EN.toLowerCase(),
    );
  };

  return (
    <div className="max-w-md px-2 sm:px-0" style={{ minWidth: "150px" }}>
      <Tab.Group
        selectedIndex={i18n.language === "ru" ? 0 : 1}
        onChange={handleClick}
      >
        <Tab.List className="flex space-x-1 rounded-xl dark:bg-neutral-800 bg-gray-200 p-1">
          {[Language.RU, Language.EN].map((lang) => (
            <Tab
              key={lang}
              className={({ selected }) =>
                classNames(
                  "w-full h-full rounded-lg py-1 text-xs font-medium leading-5 text-gray-500",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                  selected
                    ? "bg-white dark:bg-neutral-700 shadow"
                    : "text-blue-100 hover:bg-white/[0.12]",
                )
              }
            >
              {lang}
            </Tab>
          ))}
        </Tab.List>
      </Tab.Group>
    </div>
  );
}
